import { useRef, useCallback } from 'react';
import { getRoIBoundsUsingPosition, getRoIBounds } from '../helpers';
import { ROI_RECTANGLE_SPEC } from '../constants';

export const useMapBounds = () => {
    const roiBoundsRef = useRef<{ top: number; bottom: number; left: number; right: number; width: number; height: number; } | null>(null);
    const poiBoundRef = useRef<{ north: number; south: number; east: number; west: number; } | null>(null);
    const mbpBoundRef = useRef<{ north: number; south: number; east: number; west: number; } | null>(null);

    const updateBounds = useCallback((map: google.maps.Map | null) => {
        if (map) {
            roiBoundsRef.current = getRoIBoundsUsingPosition(map, ROI_RECTANGLE_SPEC.HOVER);
            poiBoundRef.current = getRoIBounds(map, ROI_RECTANGLE_SPEC.POI);
            mbpBoundRef.current = getRoIBounds(map, ROI_RECTANGLE_SPEC.MBP);
        }
    }, []);

    const updatePoiMbpBounds = useCallback((map: google.maps.Map | null) => {
        if (map) {
            poiBoundRef.current = getRoIBounds(map, ROI_RECTANGLE_SPEC.POI);
            mbpBoundRef.current = getRoIBounds(map, ROI_RECTANGLE_SPEC.MBP);
        }
    }, []);

    return {
        roiBoundsRef,
        poiBoundRef,
        mbpBoundRef,
        updateBounds,
        updatePoiMbpBounds
    };
};
